import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { useHistory } from "react-router-dom";
import useService from "../../Hooks/useService";
import WorkflowGroupService from "../../../Services/WorkflowGroup.service";
import ServiceResult, { Loaders } from "../../UI/ServiceResult/ServiceResult";
import LinkToPerson from "../Person/LinkToPerson/LinkToPerson";
import useCheckboxes from "../../Hooks/useCheckboxes";
import WorkflowNodeStatusBadge from "../WorkflowNodeStatus/WorkflowNodeStatusBadge";
import FAIcon from "../../UI/FAIcon/FAIcon";
import AlertModal from "../Alert/AlertModal";
import NewMessageModal from "../Message/NewMessageModal";
import ParamsService from "../../../Services/Shared/Params.service";
import useParams from "../../Hooks/useParams";
import Pager from "../../UI/Pager/Pager";
import ResponsiveTable from "../../UI/ResponsiveTable/ResponsiveTable";
import ItemStatusBadge from "../ItemStatusBadge/ItemStatusBadge";
import DateService from "../../../Services/Shared/Date.service";
import ItemStatusDomainService from "../../../Domain/ItemStatus/ItemStatus.service";
import WorkflowNodeStatusDomainService from "../../../Domain/WorkflowNodeStatus/WorkflowNodeStatus.service";
import useUniqueId from "../../Hooks/useUniqueId";
import { useVirtualizedApp } from "../../Hooks/useVirtualizedApp";
export const DETAIL_STATUS_URL_PARAM_NAME = "detailstatusid";
export const DETAIL_PAGE_URL_PARAM_NAME = "detailpage";
const PAGE_SIZE = 20;
const WorkflowNodeDefinitionEmailDetail = (props) => {
    const params = useParams();
    const detailPage = parseInt(params[DETAIL_PAGE_URL_PARAM_NAME], 10) || 0;
    const virtualizedAppContext = useVirtualizedApp();
    const { checkedItems, getCheckbox } = useCheckboxes();
    const [isAlertModalOpen, setIsAlertModalOpen] = React.useState(false);
    const [isMessageModalOpen, setIsMessageModalOpen] = React.useState(false);
    const history = useHistory();
    const [nodesState, loadNodes] = useService(WorkflowGroupService.nodes);
    const [direction, setDirection] = React.useState(null);
    const [order, setOrder] = React.useState(null);
    const [isStatusNegated, setIsStatusNegated] = React.useState(false);
    const usingExternalStatus = !!props.useCampaignEmailItemStatus;
    const refresh = React.useCallback(() => {
        loadNodes(props.workflowGroupId, Object.assign(Object.assign({ referenceId: props.workflowGroupReferenceId }, (props.useCampaignEmailItemStatus
            ? {
                externalStatusIds: isStatusNegated
                    ? ItemStatusDomainService.getNotCampaignEmailStatus(props.useCampaignEmailItemStatus)
                    : ItemStatusDomainService.campaignEmailStatusUpToAndIncluding(props.useCampaignEmailItemStatus),
            }
            : {
                workflowNodeStatusIds: isStatusNegated
                    ? WorkflowNodeStatusDomainService.Statuses.filter((s) => ![
                        WorkflowNodeStatusDomainService.Failed.id &&
                            WorkflowNodeStatusDomainService.Fulfilled.id,
                    ].includes(s.id)).map((s) => s.id)
                    : [WorkflowNodeStatusDomainService.Fulfilled.id],
            })), { max: PAGE_SIZE, offset: PAGE_SIZE * (detailPage || 0), order,
            direction }));
    }, [
        loadNodes,
        detailPage,
        direction,
        order,
        props.workflowGroupId,
        props.workflowGroupReferenceId,
        props.useCampaignEmailItemStatus,
        isStatusNegated,
    ]);
    React.useEffect(() => {
        refresh();
    }, [refresh]);
    const makeId = useUniqueId()[1];
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "row mt-3", children: [_jsx("div", { className: "col", children: _jsxs("div", { className: "d-flex", children: [_jsxs("button", { className: "btn btn-link", onClick: () => refresh(), disabled: nodesState.isLoading, children: [_jsx(FAIcon, { icon: "sync", addMarginRight: true, spin: nodesState.isLoading }), " ", "Refresh"] }), _jsxs("button", { disabled: !(checkedItems === null || checkedItems === void 0 ? void 0 : checkedItems.length), className: "btn btn-link", onClick: () => setIsAlertModalOpen(true), children: [_jsx(FAIcon, { icon: "bell", addMarginRight: true }), " Alert"] }), _jsxs("button", { disabled: !(checkedItems === null || checkedItems === void 0 ? void 0 : checkedItems.length), className: "btn btn-link", onClick: () => setIsMessageModalOpen(true), children: [_jsx(FAIcon, { icon: "envelope", addMarginRight: true }), " Message"] })] }) }), _jsxs("div", { className: "col d-flex align-items-center justify-content-end", children: [_jsxs("div", { className: "custom-control custom-radio custom-control-inline justify-content-end", children: [_jsx("input", { type: "radio", id: makeId("notNegated"), className: "custom-control-input", checked: !isStatusNegated, 
                                        // @ts-expect-error - TS2339 - Property 'checked' does not exist on type 'EventTarget'.
                                        onClick: (e) => setIsStatusNegated(!e.target.checked) }), _jsx("label", { className: "custom-control-label clickable", htmlFor: makeId("notNegated"), children: props.actionVerb })] }), _jsxs("div", { className: "custom-control custom-radio custom-control-inline", children: [_jsx("input", { type: "radio", id: makeId("negated"), className: "custom-control-input", checked: isStatusNegated, 
                                        // @ts-expect-error - TS2339 - Property 'checked' does not exist on type 'EventTarget'.
                                        onClick: (e) => setIsStatusNegated(e.target.checked) }), _jsxs("label", { className: "custom-control-label clickable", htmlFor: makeId("negated"), children: ["Not ", props.actionVerb] })] })] })] }), _jsx("hr", {}), _jsx("div", { children: _jsx(ServiceResult, { state: nodesState, loader: Loaders.overlay(), children: (nodes) => (_jsxs(_Fragment, { children: [_jsx(ResponsiveTable, { striped: true, rowVerticalPadding: 2, columns: [
                                    {
                                        title: "Name",
                                        onSort: (d) => {
                                            if (d) {
                                                setDirection(d);
                                                setOrder("contextPerson");
                                            }
                                            else {
                                                setDirection(null);
                                                setOrder(null);
                                            }
                                        },
                                    },
                                    {
                                        title: "Current Status",
                                        onSort: (d) => {
                                            if (d) {
                                                setDirection(d);
                                                setOrder("status");
                                            }
                                            else {
                                                setDirection(null);
                                                setOrder(null);
                                            }
                                        },
                                    },
                                    {
                                        title: "Status Date",
                                        onSort: (d) => {
                                            if (d) {
                                                setDirection(d);
                                                setOrder(usingExternalStatus
                                                    ? "externalStatusDate"
                                                    : "workflowNodeStatusDate");
                                            }
                                            else {
                                                setDirection(null);
                                                setOrder(null);
                                            }
                                        },
                                    },
                                ], rows: nodes.data.map((node) => [
                                    _jsxs(LinkToPerson, { affiliationId: node.person.affiliationId, virtualizedApp: virtualizedAppContext.name, children: [node.person.fullName, " (", node.person.studentId, ")"] }, 0),
                                    usingExternalStatus ? (
                                    // @ts-expect-error - TS2322 - Type 'ItemStatus | null | undefined' is not assignable to type 'ItemStatus'.
                                    _jsx(ItemStatusBadge, { itemStatus: node.externalStatus })) : (_jsx(WorkflowNodeStatusBadge, { workflowNodeStatusId: node.statusId, statusMap: props.statusNameMap }, 1)),
                                    usingExternalStatus
                                        ? // @ts-expect-error - TS2345 - Argument of type 'Date | null | undefined' is not assignable to parameter of type 'Date'.
                                            DateService.displayWithTime(node.externalStatusDate)
                                        : DateService.displayWithTime(node.workflowNodeStatusDate),
                                ]), addCheckboxes: {
                                    ids: nodes.data.map((node) => node.person.affiliationId),
                                    useCheckboxesMakeCheckbox: getCheckbox,
                                }, noDataComponent: "No items found" }), _jsx("div", { className: "my-3", children: _jsx(Pager, { setCurrentPage: (page) => {
                                        history.replace(ParamsService.updateCurrentParams({
                                            [DETAIL_PAGE_URL_PARAM_NAME]: page,
                                        }));
                                    }, totalPages: Math.ceil(nodes.total / PAGE_SIZE), currentPage: detailPage || 0 }) })] })) }) }), _jsx(AlertModal, { size: "xl", studentAffiliationIds: checkedItems, isOpen: isAlertModalOpen, onModalClosed: () => setIsAlertModalOpen(false) }), _jsx(NewMessageModal, { size: "xl", recipientAffiliationIds: checkedItems, isOpen: isMessageModalOpen, onModalClosed: () => setIsMessageModalOpen(false) })] }));
};
export default WorkflowNodeDefinitionEmailDetail;
